import { render, staticRenderFns } from "./WikiContainer.vue?vue&type=template&id=310bbc12"
import script from "./WikiContainer.vue?vue&type=script&lang=ts"
export * from "./WikiContainer.vue?vue&type=script&lang=ts"
import style0 from "./WikiContainer.vue?vue&type=style&index=0&id=310bbc12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports